export default __webpack_public_path__ + "static/media/Real-Time Bluedot Wayfinding.3a6719bc.svg";